module.exports = __webpack_public_path__ + "static/media/b2.42c92850.jpg";